export var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["CASH"] = 1] = "CASH";
    PaymentType[PaymentType["CHECK"] = 2] = "CHECK";
    PaymentType[PaymentType["CREDIT_CARD"] = 3] = "CREDIT_CARD";
    PaymentType[PaymentType["ACH_EFT"] = 4] = "ACH_EFT";
    PaymentType[PaymentType["WIRE"] = 5] = "WIRE";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=payment-type.js.map